import React from "react";

import { EnvContext } from "./context/env-context";
import { LangContext } from "./context/lang-context";

import PageStudio from "./views/PageStudio";

function App(props) {
  const lang = document.documentElement.lang.split("-")[0];
  const locale = document.documentElement.lang;

  const tourFallback = props.tourFallback === "true";

  return (
    <>
      <EnvContext.Provider value={props.env}>
        <LangContext.Provider value={{ lang, locale }}>
          <div className="tw-bg-white tw-relative tw-antialiased tw-font-text tw-z-10 tw-mt-[var(--pg-header-offset)]">
            <PageStudio
              id={props.id}
              shopId={props.shopId}
              lgf={props.is_livegroupfitness}
              clubtour={props.clubtour}
              tourFallback={tourFallback}
              bgmap={props.bgmap}
              yt={props.yt}
              options={props.option}
              studioinfo={props.studioinfo}
            />
          </div>
        </LangContext.Provider>
      </EnvContext.Provider>
    </>
  );
}

export default App;
